import http from './http';

export async function handlerDisputePool() {
  const { data } = await http.get('/api/handler/disputes/pool');
  return data;
}

export async function handlerDisputeInProgress() {
  const { data } = await http.get('/api/handler/disputes/in-progress');
  return data;
}

export async function takeDispute(id) {
  const { data } = await http.post(`/api/handler/disputes/${id}/take`);
  return data;
}

export async function closeDispute(id, payload) {
  const { data } = await http.post(`/api/handler/disputes/${id}/reply-close`, payload);
  return data;
}

export async function releaseDispute(id) {
  const { data } = await http.post(`/api/handler/disputes/${id}/release`);
  return data;
}
